/**
 * Form Validator Module
 */

export class FormValidator {
    /**
     * Validate email format
     */
    validateEmail(email: string): boolean {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    }

    /**
     * Get field error message
     */
    getFieldError(fieldName: string, value: string): string | null {
        // Check required fields
        const requiredFields = ['first_name', 'last_name', 'email', 'message'];
        if (requiredFields.includes(fieldName) && !value.trim()) {
            return window.rediGroupAjax?.translations.error || 'This field is required';
        }

        // Email validation
        if (fieldName === 'email' && value && !this.validateEmail(value)) {
            return 'Please enter a valid email address';
        }

        // Length validation
        const maxLengths: { [key: string]: number } = {
            first_name: 50,
            last_name: 50,
            company: 100,
            message: 5000
        };

        if (maxLengths[fieldName] && value.length > maxLengths[fieldName]) {
            return `Maximum ${maxLengths[fieldName]} characters allowed`;
        }

        return null;
    }

    /**
     * Validate entire form
     */
    validateForm(formData: FormData): { valid: boolean; errors: Map<string, string> } {
        const errors = new Map<string, string>();
        
        // Check privacy checkbox
        if (!formData.get('privacy_accepted')) {
            errors.set('privacy_accepted', 'Please accept the privacy policy');
        }

        // Validate all fields
        const fieldsToValidate = ['first_name', 'last_name', 'email', 'message', 'company'];
        
        fieldsToValidate.forEach(field => {
            const value = formData.get(field) as string || '';
            const error = this.getFieldError(field, value);
            if (error) {
                errors.set(field, error);
            }
        });

        return {
            valid: errors.size === 0,
            errors
        };
    }
}